<script lang="ts" setup>
import type ResponseData from '@/types/ResponseData'
import CompanyDataService from '@/services/CompanyDataService'
import type Company from '@/types/Company'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import { onMounted, ref, computed } from 'vue';
import store from '@/store'

const currentOrder = computed(() => store.state.currentOrder);
const currentCompany = ref({} as Company);

async function getCompany(id: any) {
    await CompanyDataService.getCompanyById(id)
        .then((response: ResponseData) => {
            currentCompany.value = response.data.data
        })
        .catch((e: Error) => {
            toast.error('Chyba: ' + e.message)
        })
}

async function refreshData() {
    await getCompany(currentOrder.value.company_id)
}

onMounted(async () => {
    await refreshData();
})
</script>

<template>
    <div
        class="bg-gradient-to-br from-white via-slate-50 to-slate-100 rounded-2xl shadow-lg p-6 border border-gray-100 max-w-lg mx-auto flex flex-col gap-6">
        <div class="flex items-center gap-3 mb-2 border-b border-slate-200 pb-3">
            <svg class="w-7 h-7 text-teal-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
                aria-hidden="true">
                <rect x="3" y="7" width="18" height="10" rx="2" stroke="currentColor" stroke-width="2" fill="none" />
                <path d="M7 7V5a5 5 0 0 1 10 0v2" stroke="currentColor" stroke-width="2" fill="none" />
                <path d="M8 15h8" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
            <span class="text-2xl font-bold text-slate-900 tracking-tight">Bizinix Doklady</span>
            <span class="ml-auto flex items-center gap-1">
                <span class="text-lg font-semibold text-teal-700" tabindex="0" aria-label="Ročný poplatok"
                    title="Ročný poplatok za doklady">{{ currentOrder.amount }}€ <span
                        class="text-xs text-slate-500 font-normal">/ rok</span></span>
                <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" stroke-width="1.5"
                    viewBox="0 0 24 24" aria-hidden="true">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" fill="none" />
                    <path d="M12 8v4m0 4h.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                </svg>
            </span>
        </div>
        <div class="flex flex-col gap-2">
            <label for="zaplatenedo" class="block text-sm font-medium text-gray-700">Balík zaplatený do:</label>
            <FormKit type="text" v-model="currentCompany.fakturacia_zaplatene_do" name="zaplatenedo" id="zaplatenedo"
                aria-label="Dátum do ktorého je balík zaplatený"
                class="mt-1 focus:ring-2 focus:ring-teal-500 focus:border-teal-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md transition duration-150 ease-in-out hover:border-teal-400 hover:shadow focus:outline-none" />
        </div>
        <div class="flex justify-end mt-2">
            <span class="text-xs text-slate-500 italic">Údaje sú aktualizované podľa poslednej fakturácie.</span>
        </div>
    </div>
</template>